import NextImage, { ImageProps as NextImageProps } from 'next/image';
import Styled from './Image.styled';

type ImageProps = {
  height?: string;
  width?: string;
} & Omit<NextImageProps, 'width' | 'height'>;

function Image({ width, height, className, ...props }: ImageProps): JSX.Element {
  return (
    <Styled.ImageWrapper $width={width} $height={height} className={className}>
      <NextImage {...props} />
    </Styled.ImageWrapper>
  );
}

export default Image;
